import { useActiveTenant } from '@states/active-tenant.atom';
import { useBrandingColors } from '../../states/theme.atom';
import { useMemo } from 'react';

export const AppLogo = () => {
  const { primaryColor, secondaryColor } = useBrandingColors();
  const { activeTenant } = useActiveTenant();
  const fallbackLogo = '/media/branding/probot.png';

  const logo = useMemo(() => {
    return (activeTenant?.logo as string) || fallbackLogo;
  }, [activeTenant]);

  return <img className="img-fluid w-75 my-3" src={logo} alt="ProBot" />;
};
